import React from 'react';

import {FBCommentQuestionToolTip} from 'components/break/tooltips/breaks-steps-section-tool-tips';

import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';
import IndexedSubSectionWrapper from "../../../../../hoc/IndexedSubSectionWrapper";
import {
  MemoryMatchHeadlineToolTip,
  MemoryMatchIntroToolTip,
  MemoryMatchBackgroundColorToolTip,
  MemoryMatchGridSizeToolTip,
  MemoryMatchCardFrontImageToolTip,
  MemoryMatchCardPairToolTip
} from 'components/break/tooltips/memory-match-tool-tips';

export default {
    name: "memoryMatchGame",
    subSection: true,
    resource: true,
    hideIfResourceIsNoU: true,

    fields: [
        {
          type: 'contenteditable',
          name: 'headline',
          required: true,
          // Headline is only allowed if there is more than one step
          showField: (proxy) => (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
          linkedField: (proxy) => ["title"],
          props: {
              labelKey: 'editbreak.steps.memory_match.headline',
              helpContent:  <MemoryMatchHeadlineToolTip/>,
              helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.memory_match.headline'}/></IntlProvider>
          }
        },
        {
            type: 'contenteditable',
            name: 'introCopy',
            required: false,
            props: {
              labelKey: 'editbreak.steps.memory_match.intro_copy',
              maxLength: 500,
              placeholderKey: 'editbreak.steps.memory_match.intro_copy.placeholder',
              helpContent:  <MemoryMatchIntroToolTip/>,
              helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.memory_match.intro_copy'}/></IntlProvider>,
              validationRules: [
                  {
                      type: 'MarkupTextLimit',
                      params: {
                          limit: 500
                      }
                  }
              ]

            }
        },
        {
            type: 'text',
            name: 'commentQuestion',
            showField: (proxy) => (proxy.currentBaseResource.showFBComments && proxy.currentBaseResource.sponsoredType !== 'sponsored' ),
            props: {
                labelKey: 'editbreak.steps.related_breaks.commentQuestion',
                helpContent: <FBCommentQuestionToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.fbCommentQuestion'}/></IntlProvider>
            }
        },
        {
            type: 'color',
            name: 'backgroundClr',
            required: true,
            linkedField: (proxy) => ["missionColor7"],
            showField: (proxy) => (proxy.currentBaseResource.sponsoredType === 'sponsored'),
            props: {
                labelKey: 'editbreak.steps.memory_match.bgColor',
                helpContent:  <MemoryMatchBackgroundColorToolTip/>,
                helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.memory_match.bgColor'}/></IntlProvider>
            }
        },
        {
          type: 'radio',
          name: 'numCards',
          required: true,
          showField: (proxy) => (proxy.currentBaseResource.sponsoredType === 'sponsored'),
          props: {
            labelKey: 'editbreak.steps.memory_match.grid_size',
            helpContent:  <MemoryMatchGridSizeToolTip/>,
          helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.memory_match.grid_size'}/></IntlProvider>,
            colCount: 3,
            options: [
              {
                value: 8,
                textKey: 'editbreak.steps.memory_match.grid_size.8'
              },
              {
                value: 12,
                textKey: 'editbreak.steps.memory_match.grid_size.12'
              },
              {
                value: 16,
                textKey: 'editbreak.steps.memory_match.grid_size.16'
              }
            ]
          }
        },
        {
            type: 'image',
            name: 'defaultFrontImage',
            idFor: 'defaultFrontImageAsset',
            required: true,
            editable: (formProxy) => formProxy.currentBaseResource.sponsoredType === "sponsored",

            props: {
                labelKey: 'editbreak.steps.memory_match.defaultFrontImage',
                imageType: 'memoryMatchCard',
                helpContent:  <MemoryMatchCardFrontImageToolTip/>,
                helpHeader:   <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.memory_match.defaultFrontImage'}/></IntlProvider>
            }
        },
        {
            subSection: true,
            sectionWrapper: IndexedSubSectionWrapper,

            props: {
                headerKey: "editbreak.steps.memory_match.cards"
            },

            fields: [
                {
                    name: 'cards',
                    subSection: true,
                    resource: true,
                    collection: true,
                    behavior: {
                        type: 'matchBy',
                        matchFields: {
                            from: 'id',
                            to: 'matchingCardId'
                        },
                        use: 'first'
                    },

                    fields: [
                        {
                            type: 'image',
                            name: 'rearImageId',
                            idFor: 'rearImage',
                            required: true,

                            props: {
                                labelKey: 'editbreak.steps.memory_match.card.rear_image',
                                imageType: 'memoryMatchCard',
                                helpContent:  <MemoryMatchCardPairToolTip/>,
                                helpHeader: 'editbreak.steps.memory_match.card.rear_image'
                            }
                        }
                    ]
                }
            ]
        }
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/memory-match.js